import React from 'react';
import {Body, Section, Div1, Div2} from './seminariosStyle';
import imagenes from '../../Assets/imagenes';
import FormSeminarios from './FormSeminarios';

const Seminarios = () => {
    return (
        <Body>
            <Section>
                <Div1>
                    <img src={imagenes.evento} alt="" />
                </Div1> 
                <Div2>
                    <FormSeminarios/>
                </Div2>
            </Section>
        </Body>
    )
}
export default Seminarios;